import { render, staticRenderFns } from "./ManufacturerTypeAddLayer.vue?vue&type=template&id=74a7cdd7&scoped=true&"
import script from "./ManufacturerTypeAddLayer.vue?vue&type=script&lang=js&"
export * from "./ManufacturerTypeAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerTypeAddLayer.vue?vue&type=style&index=0&id=74a7cdd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7cdd7",
  null
  
)

export default component.exports